import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaCheck, FaEnvelope, FaEnvelopeOpenText, FaRegQuestionCircle, FaTimes, FaTrash } from 'react-icons/fa';
import InfoComplete from './InfoComplete';
import InfoToValidate from './InfoToValidate';
import GenereCsv from './GenereCsv';
import InfoCotisation from './InfoCotisation';
import { cleanJson } from './utils/Columns';
import CotisationSel from './CotisationSel';
import TarifManuel from './TarifManuel';
import Stepper from 'react-stepper-horizontal';

const AdhesionByType = ({ gotoAuth }) => {

    const url = localStorage.getItem('url');
    const smallurl = localStorage.getItem('smallurl');
    const cotisations = JSON.parse(localStorage.getItem('cotisations')) || [];

    const [showMaj, setShowMaj] = useState(false);
    const [show, setShow] = useState(false);
    const [adherentSel, setAdherentSel] = useState({});
    // Filtrer les articles initialisés et non initialisés
    const code = localStorage.getItem('code');

    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [dataFiltered, setDataFiltered] = useState([]);
    const [allData, setAllData] = useState([]);
    const [titre, setTitre] = useState('');

    useEffect(() => {
        if (url && url !== '') {
            getData();
        }
    }, []);

    const filtreData = (mydata, step) => {
        //if step.etat='' alors on affiche tout
        let donnees = [];
        if (step.etat === '') {
            donnees = mydata;
        } else {
            donnees = mydata.filter(d => d.etat === step.etat);
        }
        setTitre(step.title);

        setData(donnees);
        filtre(searchText, donnees);
    }
    // validated

    const getData = () => {
        console.log('code', code);
        if (code === '') {
            gotoAuth();
            return;
        }
        // Appel de l'API
        fetch(`${url}GetCotisationsAdherents/${code}`)
            .then(response => response.json())
            .then(data => {
                // Traiter la réponse si nécessaire
                console.log('Réponse du serveur:', data);
                if (data === '0' || !data.data)
                    gotoAuth();
                else {
                    setShowTarif(false)
                    let donnees = cleanJson(data.data);
                    setAllData(donnees);
                    filtreData(donnees, currentEtat);
                }
            })
            .catch(error => console.error('Erreur:', error));
    }

    const filtre = (value, mydata) => {
        console.log('filtre', value, mydata);
        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(mydata);
        } else {
            const filtered = mydata.filter(item => {
                // must contains all word of value
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered(filtered);
            // console.log(filtered);
        }
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, data);
    };

    const handleClose = () => setShow(false);

    const handleShow = (row) => {
        setAdherentSel(row);
        setShow(true);
    }

    const [showCotis, setShowCotis] = useState(false);
    const [cotisationSel, setCotisationSel] = useState({});

    const handleCotisation = (row) => {
        // console.log(row, cotisations);
        let cotis = cotisations.find(c => c.id === row.cotisation_id);
        setAdherentSel(row);
        // console.log(cotis);
        setCotisationSel(cotis);
        setShowCotis(true);
    }

    // download pdf src = url + value
    const downloadPdf = (value) => {
        fetch(smallurl + value)
            .then(response => response.blob())
            .then(blob => {
                // console.log(blob);
                const pdfurl = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                // console.log(url);
                const link = document.createElement('a');
                link.href = pdfurl;
                link.setAttribute(
                    'download',
                    `cotisation_${adherentSel.nom_de_l_entreprise}.pdf`,
                );
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            });
    }


    const sendAllFeuille = (feuille) => {
        console.log('sendAllFeuille', feuille);
        let cotisation = cotisations.find(c => c.reference === feuille);
        console.log(cotisation);
        if (window.confirm(`Voulez-vous envoyer tous les mails de la ${feuille} ?\r\n${cotisation.titre}`)) {
            // return ;
            fetch(`${url}SendAllCotisation/${cotisation.id}/${code}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        gotoAuth();
                    else {
                        // console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const [showTarif, setShowTarif] = useState(false);

    const OpenMail = (corps, subject) => {
        // simulate click on href mailto : lien
        // console.log(lien);
        const link = document.createElement('a');
        const bodyEncoded = encodeURIComponent(corps);
        link.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${bodyEncoded}`

        link.setAttribute(
            'target',
            '_blank',
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

    }

    const handleGetLien = (row) => {
        console.log('handleGetLien', row);
        if (window.confirm(`La création de ce lien rendra les liens précédemmeent envoyés inactifs.\r\nVoulez-vous créer un nouveau lien d'adhésion pour ${row.prenom_adherent} ${row.nom_adherent} ${row.e_mail_1} ?`)) {

            fetch(`${url}GetMailAvecLien/${code}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                // remplace 'Invalid date' par '' dans le JSON
                //adherent_id, cotisation_id, choix_id, code, mail
                body: JSON.stringify({ appel_cotisation_id: row.appel_cotisation_id, adherent_id: row.adherent_id, cotisation_id: row.cotisation_id, mail: row.e_mail_1 })
            })
                .then(response => response.json())
                .then(data => {
                    if (data === '0' || !data.status)
                        gotoAuth();
                    else {
                        console.log(data.data);
                        OpenMail(data.corps.replace(/¤/g, '\n'), data.subject);
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleMail = (e, row) => {
        e.stopPropagation();
        console.log(row)

        if (window.confirm(`Voulez-vous envoyer une demande de cotisation à ${row.prenom_adherent} ${row.nom_adherent} ${row.e_mail_1} ?`)) {

            // fetch(`${url}SendCotisation/${row.adherent_id}/${code}`)
            fetch(`${url}SendCotisation/${code}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                // remplace 'Invalid date' par '' dans le JSON
                //adherent_id, cotisation_id, choix_id, code, mail
                body: JSON.stringify({ appel_cotisation_id: row.appel_cotisation_id, adherent_id: row.adherent_id, cotisation_id: row.cotisation_id, mail: row.e_mail_1 })
            })
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    // console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        gotoAuth();
                    else {
                        // console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }


    const [showCotisSel, setShowCotisSel] = useState(false);

    const handleDelCotisation = () => {
        console.log('handleDelCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr de supprimer la cotisation de ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}AffecteCotisation/${adherentSel.adherent_id}/0/0`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }



    const handleChoixCotisation = (e) => {
        console.log('handleChoixCotisation', e)
        let reference = cotisations.find(c => c.id === e.cotisation_id).reference;
        // console.log('handleChoixCotisation', e, reference);
        console.log('handleChoixCotisation', adherentSel);
        if (window.confirm(`Êtes vous sûr d'affecter la ${reference} à ${adherentSel.nom_de_l_entreprise} - ${adherentSel.prenom_adherent} ${adherentSel.nom_adherent} ?`)) {

            fetch(`${url}AffecteCotisation/${adherentSel.adherent_id}/${e.cotisation_id}/${e.choix_id}`)
                .then(response => response.json())
                .then(data => {
                    // Traiter la réponse si nécessaire
                    console.log('Réponse du serveur:', data);
                    if (data === '0' || !data.status)
                        alert("rien à envoyer")
                    else {
                        console.log(data.data);
                        getData();
                    }
                })
                .catch(error => console.error('Erreur:', error));
        }
    }

    const handleFeuilleClick = (row) => {
        console.log('Ligne cliquée :', row);
        // Faites ce que vous voulez avec la ligne cliquée ici
        setAdherentSel(row);
        setShowCotisSel(true);
    };

    const columns = [
        // { name: 'ID', selector: row => row.id, sortable: true, wrap: true },
        { name: 'Siret', selector: row => row.siret, sortable: true, wrap: true },
        // { name: 'Numéro TVA Intracommunautaire', selector: row => row.numero_tva_intracommunautaire, sortable: true, wrap: true },
        // { name: 'Code APE ou NAF', selector: row => row.code_ape_ou_naf, sortable: true, wrap: true },
        // { name: 'Forme Juridique de la Société', selector: row => row.forme_juridique_de_la_societe, sortable: true, wrap: true },
        // { name: 'Montant du Capital', selector: row => row.montant_du_capital, sortable: true, wrap: true },
        { name: 'Entreprise', selector: row => row.nom_de_l_entreprise, sortable: true, wrap: true },
        { name: 'Adhérent', selector: row => <>{row.civilite}. {row.prenom_adherent} {row.nom_adherent}</>, sortable: true, wrap: true },
        { name: 'Réseau', selector: row => row.reseau, sortable: true, wrap: true },
        {
            name: 'Cotisation', selector: row => row.reference, cell: row => (<>
                {row.reference === '' && <Button variant="outline-danger" onClick={() => handleFeuilleClick(row)}>Feuille ?</Button>}
                {row.reference !== '' && <>
                    <Button variant="link" onClick={() => handleFeuilleClick(row)}>{row.reference}</Button>&nbsp;<FaRegQuestionCircle onClick={() => handleCotisation(row)} />
                </>}
            </>), sortable: true, wrap: true
        },

        // {
        //     name: 'Adh', width: '90px', selector: row => row.cotisation_nationale_t1, cell: row => (<>
        //         {/* {row.cotisation_nationale_t1 === 0 && <Badge variant="danger">Non payé</Badge>}
        //         {row.cotisation_nationale_t1 > 0 && <Badge variant="success">Payé</Badge>} */}
        //         {row.cotisation_nationale_t1 ? row.cotisation_nationale_t1 : 0} €
        //     </>), sortable: true, wrap: true
        // },
        // {
        //     name: 'Région', width: '90px', selector: row => row.cotisation_regionale, cell: row => (<>
        //         {/* {row.cotisation_nationale_t1 === 0 && <Badge variant="danger">Non payé</Badge>}
        //         {row.cotisation_nationale_t1 > 0 && <Badge variant="success">Payé</Badge>} */}
        //         {row.cotisation_regionale && row.cotisation_regionale !== '' ? row.cotisation_regionale : 0} €
        //     </>), sortable: true, wrap: true
        // },
        // {
        //     name: 'Réseau', width: '90px', selector: row => row.cotisation_reseau, cell: row => (<div className="pull-right">
        //         {row.cotisation_reseau ? row.cotisation_reseau : 0} €
        //     </div>), sortable: true, wrap: true
        // },
        // {
        //     name: <>Paiement<br />Adh / Région / Réseau</>, selector: row => row.cotisation_nationale_t1, cell: row => (<>
        //         {/* {row.cotisation_nationale_t1 === 0 && <Badge variant="danger">Non payé</Badge>}
        //         {row.cotisation_nationale_t1 > 0 && <Badge variant="success">Payé</Badge>} */}
        //         {row.cotisation_nationale_t1 ? row.cotisation_nationale_t1 : 0} /&nbsp; 
        //         {row.cotisation_regionale && row.cotisation_regionale !== '' ? row.cotisation_regionale : 0} /&nbsp;
        //         {row.cotisation_reseau ? row.cotisation_reseau : 0}
        //     </>), sortable: true, wrap: true
        // },
        //         cotisation_nationale_t1
        // : 
        // 480
        // cotisation_regionale
        // : 
        // ""
        // cotisation_reseau
        // : 
        // ""
        // {
        //     name: 'Actions', width: '80px', cell: row => (<>
        //         <Button variant='secondary' onClick={() => handleShow(row)}><FaPen /></Button>
        //     </>),
        // },
        // {
        //     name: 'Suppr', width: '80px', cell: row => (<>
        //         <Button variant='danger' onClick={(e) => handleDel(e, row)}><FaTrash /></Button>
        //     </>),
        // },
        {
            name: 'Action', width: '100px', selector: row => <>{"" + row.is_actif + row.has_connected + row.has_merged}</>, cell: row => (<>
                <Button variant='secondary' onClick={(e) => handleMail(e, row)}><FaEnvelope /></Button>
                {row.is_actif === 1 && row.has_selected_paiement === 1 && row.has_merged === 0 && <>&nbsp;<Button variant='primary' onClick={() => handleMaj(row)}><FaEnvelopeOpenText /></Button></>}
            </>), sortable: true, wrap: true,
        },
        // {
        //     name: 'Etat', width: '80px', selector: row => <>{"" + row.is_actif + row.has_connected + row.has_merged}</>, cell: row => (<>
        //         {/* {Object.keys(row.has_merged).length === 0 && row.is_actif !== 1 && row.is_actif !== 0 && <Button variant='secondary' onClick={(e) => handleMail(e, row)}><FaEnvelope /></Button>} */}
        //         {row.is_actif === 1 && row.has_connected === 0 && row.has_merged === 0 && <><FaEnvelopeOpen /></>}
        //         {row.is_actif === 1 && row.has_connected === 1 && row.has_merged === 0 && <Button variant='primary' onClick={() => handleMaj(row)}><FaEnvelopeOpenText /></Button>}
        //         {row.is_actif === 1 && row.has_connected === 1 && row.has_merged === 1 && row.paid===1 && <div style={{ color: 'green', padding: '5px' }}><FaCheck /></div>}
        //         {/* {"" + row.is_actif + row.has_connected + row.has_merged} */}
        //     </>), sortable: true, wrap: true,
        // },
        {
            name: 'Actuellement', selector: row => <>{"" + row.is_actif + row.has_connected + row.has_merged}</>, cell: row => (<>
                {/* {Object.keys(row.has_merged).length === 0 && row.is_actif !== 1 && row.is_actif !== 0 && <Button variant='secondary' onClick={(e) => handleMail(e, row)}><FaEnvelope /></Button>} */}
                {row.reference === '' && !row.is_actif && <>Feuille non sélectionné</>}
                {row.reference !== '' && !row.is_actif && <>Feuille sélectionné</>}
                {row.is_actif === 1 && row.has_connected === 0 && <>Mail envoyé</>}
                {row.is_actif === 1 && row.has_connected === 1 && row.has_filled === 0 && <>S'est connecté</>}
                {row.is_actif === 1 && row.has_filled === 1 && row.has_selected_paiement === 0 && <>A remplit<br />ses informations</>}
                {row.is_actif === 1 && row.has_selected_paiement === 1 && row.has_merged === 0 && <>A sélectionné son<br />moyen de paiement</>}
                {row.is_actif === 1 && row.has_merged === 1 && row.paid === 0 && <>Données validé<br />par la FFC</>}
                {row.is_actif === 1 && row.paid === 1 && row.has_merged === 1 && <>Dossier finalisé</>}
            </>), sortable: true, wrap: true,
        },
        {
            name: 'En attente', selector: row => <>{"" + row.is_actif + row.has_connected + row.has_merged}</>, cell: row => (<>
                {/* {Object.keys(row.has_merged).length === 0 && row.is_actif !== 1 && row.is_actif !== 0 && <Button variant='secondary' onClick={(e) => handleMail(e, row)}><FaEnvelope /></Button>} */}
                {row.reference === '' && !row.is_actif && <>Feuille à sélectionné</>}
                {row.reference !== '' && !row.is_actif && <>Mail à envoyé</>}
                {row.is_actif === 1 && row.has_connected === 0 && <>De connexion</>}
                {row.is_actif === 1 && row.has_connected === 1 && row.has_filled === 0 && <>De remplissage de<br />ses informations</>}
                {row.is_actif === 1 && row.has_filled === 1 && row.has_selected_paiement === 0 && <>De sélection de<br />moyen de paiement</>}
                {row.is_actif === 1 && row.has_selected_paiement === 1 && row.has_merged === 0 && <>de vérification<br />des données<br />par la FFC</>}
                {row.is_actif === 1 && row.has_merged === 1 && row.paid === 0 && <>De paiement</>}
                {/* {row.is_actif === 1 && row.paid === 1 && <>Rien</>} */}
                {/* {"" + row.is_actif + row.has_connected + row.has_merged} */}
            </>), sortable: true, wrap: true,
        },
        {
            name: 'Payé', width: '80px', selector: row => <>{"" + row.is_actif + row.has_connected + row.has_merged}</>, cell: row => (<>
                {row.is_actif === 1 && row.paid === 1 && <div style={{ color: 'green', padding: '5px' }}><FaCheck /></div>}
            </>), sortable: true, wrap: true,
        },
        // {
        //     name: 'Manuelle', width: '80px', selector: row => <>{"" + row.is_actif + row.has_connected + row.has_merged}</>, cell: row => (<>
        //         {/* <Button variant='outline-primary' onClick={(e) => manuelle(e, row)}><FaRegHandPaper /></Button> */}
        //         {row.choix_id !== '' && <Button variant='outline-primary' onClick={(e) => manuelle(e, row)}><FaRegHandPaper /></Button>}
        //     </>), sortable: true, wrap: true,
        // },

        // {
        //     name: 'Pdf', width: '80px', cell: row => (<>
        //         <Button variant='danger' onClick={(e) => handlePdf(e, row)}><FaFilePdf /></Button>
        //     </>),
        // },
        {
            name: `Liens d'adhésion`, cell: row => (<>
                {row.reference !== '' && row.paid !== 1 && <Button variant='outline-warning' onClick={() => handleGetLien(row)}><FaEnvelopeOpenText /></Button>}
            </>), sortable: true, wrap: true,
        },


    ];

    const handleMaj = (row) => {
        console.log(row);
        setAdherentSel(row);
        setShowMaj(true);
    }

    const uniqueNetworks = [...new Set(data.map(row => row.reseau))].sort();
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const handleNetworkFilter = (network) => {
        setSelectedFeuille('');
        setSelectedNetwork(network);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (network === '') {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => item.reseau === network);
            setDataFiltered(filtered);
        }
    };

    const uniqueFeuilles = [...new Set(data.map(row => row.reference))].sort();
    const [selectedFeuille, setSelectedFeuille] = useState('');
    const handleFeuilleFilter = (feuille) => {
        setSelectedNetwork('');
        setSelectedFeuille(feuille);
        // Appliquer le filtre sur les données en fonction du réseau sélectionné
        if (feuille === '') {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => item.reference === feuille);
            setDataFiltered(filtered);
        }
    };

    const etats = [
        { title: 'Tout', etat: '' },
        { title: 'Sans feuille de cotisation', etat: 'nocotisationid' },
        { title: 'A envoyer', etat: 'tobesend' },
        { title: 'Mail envoyé', etat: 'sent' },
        { title: 'Données complétées', etat: 'filled' },
        { title: 'Paiement sélectionné', etat: 'paiementselected' },
        { title: 'Validé', etat: 'valide' },
        { title: 'Finalisé', etat: 'paid' }]

    const [currentEtat, setCurrentEtat] = useState(etats[0])
    const steps = etats.map((el, index) => {
        // console.log(el.etat, currentEtat)
        return {
            title: <>{el.etat === currentEtat.etat && <h6 style={{ color: 'red' }}>{el.title}</h6>}
                {el.etat !== currentEtat.etat && el.title}
            </>,
            href: '#',
            onClick: (e) => {
                console.log('onClick', el.etat);
                e.preventDefault();
                setCurrentEtat(el);
                filtreData(allData, el);
            }
        }
    });


    const currentStep = etats.length;

    return (
        <div>
            {/* <Button variant="secondary" onClick={() => setShowNew(true)}>
                Nouvel adhérent
            </Button>
            a envoyer : <FaPaperPlane />
            envoyé : <FaEnvelope />
            connecté sur le site :<FaEnvelopeOpen />
            mergé : <FaEnvelopeOpenText /> */}
            <Stepper steps={steps} activeStep={currentStep} />

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <h1 style={{ marginLeft: '10px' }}>{titre}</h1>

                <div style={{ flexGrow: 1 }} />
                <h3 style={{ marginLeft: '10px' }}>{selectedNetwork}</h3>
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '300px' }} onChange={(e) => handleNetworkFilter(e.target.value)} value={selectedNetwork}>
                    <option value="">Tous les réseaux</option>
                    {uniqueNetworks.map((network, index) => <option key={index} value={network}>{network}</option>)}
                </Form.Select>

            </div>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                {/* <h1 style={{ marginLeft: '10px' }}>Adhésion</h1> */}
                <div style={{ flexGrow: 1 }} />
                <h3 style={{ marginLeft: '10px' }}>{selectedFeuille}</h3>&nbsp;&nbsp;{currentEtat.etat === 'tobesend' && selectedFeuille && selectedFeuille !== '' && <Button variant="secondary" onClick={() => sendAllFeuille(selectedFeuille)}><FaEnvelope /></Button>}
                <div style={{ flexGrow: 1 }} />
                <Form.Select style={{ width: '300px' }} onChange={(e) => handleFeuilleFilter(e.target.value)} value={selectedFeuille}>
                    <option value="">Toutes les feuilles</option>
                    {uniqueFeuilles.map((feuille, index) => <option key={index} value={feuille}>{feuille}</option>)}
                </Form.Select>

            </div>

            <DataTable
                columns={columns}
                data={dataFiltered}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                subHeader
                subHeaderComponent={(

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                        <input
                            type="text"
                            value={searchText}
                            onChange={handleChangesearchText}
                            // onChange={(e) => setSearchText(e.target.value)}
                            placeholder="Rechercher..."
                        />
                        {searchText && <FaTimes className='h-5' onClick={() => filtre('', data)} />}
                        <div style={{ flexGrow: 1 }} />
                        <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} />
                    </div>
                )}
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                paginationComponentOptions={{
                    rowsPerPageText: 'Lignes par page:',
                }}
            // onRowClicked={handleRowClick}
            />

            <Modal size="xl" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title><b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoComplete adherentLight={adherentSel} cotisation={dataFiltered} gotoAuth={gotoAuth} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showCotis} onHide={() => setShowCotis(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Cotisation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoCotisation cotisation={cotisationSel} choix_id={adherentSel.choix_id} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showCotisSel} onHide={() => setShowCotisSel(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Sélection d'une cotisation pour <b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button variant='outline-danger' onClick={handleDelCotisation}><FaTrash /></Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CotisationSel gotoAuth={gotoAuth} handleChoixCotisation={handleChoixCotisation} closemodal={() => setShowCotisSel(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showMaj} onHide={() => setShowMaj(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>{adherentSel.nom_de_l_entreprise}</b> - {adherentSel.civilite}. {adherentSel.prenom_adherent} {adherentSel.nom_adherent}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InfoToValidate adherentLight={adherentSel} gotoAuth={gotoAuth} reloadData={getData} closemodal={() => setShowMaj(false)} />
                </Modal.Body>
            </Modal>

            <Modal size="xl" show={showTarif} onHide={() => setShowTarif(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><b>Selection du tarif</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TarifManuel adherentSel={adherentSel} reloadData={getData} />
                </Modal.Body>
            </Modal>

        </div >
    );
}

export default AdhesionByType;
